import React from "react";

export const DefaultLayout: React.FC = ({ children }) => {
    return <div>{children}</div>;
};
